import type { CSSProperties } from "react"
import type { MeetingTypeDefinition } from "@/schema"

export const SYSTEM_MEETING_TYPE_ORDER = ["client_review", "client_check_in", "prospect", "coi", "internal", "other"]

export function humanizeMeetingTypeKey(key?: string | null): string {
  if (!key) return "Other"

  return key
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ")
}

export function activeMeetingTypes(
  meetingTypes: MeetingTypeDefinition[] | undefined,
  currentKey?: string | null
): MeetingTypeDefinition[] {
  const active = (meetingTypes ?? []).filter((meetingType) => !meetingType.archived_at)
  if (!currentKey || active.some((meetingType) => meetingType.key === currentKey)) return active

  const archivedCurrent = meetingTypes?.find((meetingType) => meetingType.key === currentKey)
  return archivedCurrent ? [...active, archivedCurrent] : active
}

export function findMeetingType(
  meetingTypes: MeetingTypeDefinition[] | undefined,
  key?: string | null
): MeetingTypeDefinition | undefined {
  return meetingTypes?.find((meetingType) => meetingType.key === key)
}

export function meetingTypeLabel(meetingTypes: MeetingTypeDefinition[] | undefined, key?: string | null): string {
  return findMeetingType(meetingTypes, key)?.name ?? humanizeMeetingTypeKey(key)
}

export function meetingTypeSwatchStyle(color?: string | null): CSSProperties {
  if (!color) return {}

  return {
    borderColor: `color-mix(in srgb, ${color} 55%, var(--foreground))`,
    color: `color-mix(in srgb, ${color} 40%, var(--foreground))`,
    backgroundColor: `color-mix(in srgb, ${color} 10%, var(--background))`,
  }
}
